import { useState, useEffect } from "react";
import { Button, Container, Grid } from "@material-ui/core";
import Api from "lib/api/httpRequestHelper";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import HeaderClientes from "components/_refactor/headers/clients";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import FilterCard from "components/_refactor/filter-card";
import TableRules from "./components/table-rules";
import DialogRules from "./components/dialog-rules";

import { Add } from "@mui/icons-material";

export default function AdmTaxas() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(25);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [searching, setSearching] = useState(false);
  const [type, setType] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [rule, setRule] = useState(null);
  const [typeOptions, setTypeOptions] = useState([]);

  const snackbar = useSnackbar();

  const handleSearchRules = async ({ page = 0, sizePerPage = 25 }) => {
    setSearching(true);
    try {
      const response = await Api.get(
        "list-billing-rules",
        "franquias",
        `?page=${page}&pageSize=${sizePerPage}&idTipoCobranca=${
          type?.value || ""
        }`,
        true
      );
      setData(
        response.Result.Items.map((item) => ({
          ...item,
          Vigencia: `${item.DataInicioVigenciaFormat} - ${item.DataFimVigenciaFormat}`,
        }))
      );
      setTotalRegistros(response.Result.TotalItems || 0);
      setPage(response.Result.Pagina || 0);
      setSizePerPage(response.Result.PageSize || 25);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar as regras: " + error.message, {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const handleSearchBillingTypes = async () => {
    setSearching(true);
    try {
      const response = await Api.get(
        "list-billing-types",
        "franquias",
        "",
        true
      );
      const formattedTypes = response.Result.Items.map((item) => ({
        label: item.Nome,
        value: item.IdFranquiaTipoCobranca,
      }));
      setTypeOptions(formattedTypes);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar os tipos de cobrança: " + error, {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  useEffect(() => {
    handleSearchRules({ page: 0, sizePerPage: 25 });
    handleSearchBillingTypes();
  }, []);

  return (
    <>
      <HeaderClientes section="Administração de Franquias" subsection="Taxas" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearchRules}
          searching={searching}
          handleClearFilters={() => setType(null)}
        >
          <Grid item xs={12} md={6}>
            <AutoCompleteField
              label="Tipo de Regra"
              value={type}
              onChange={(e) => setType(e)}
              disabled={searching}
              options={typeOptions}
              optionLabelKey="label"
              optionIdKey="value"
            />
          </Grid>
        </FilterCard>
        {data.length ? (
          <TableRules
            data={data}
            page={page}
            sizePerPage={sizePerPage}
            totalRegistros={totalRegistros}
            onTableChange={(_, { page, sizePerPage }) => {
              handleSearchRules({ page: page - 1, sizePerPage });
            }}
            onAction={(row) => {
              setRule(row);
              setOpenDialog(true);
            }}
            extraActions={() => setOpenDialog(true)}
          />
        ) : (
          <Grid
            container
            spacing={2}
            justify="flex-end"
            style={{ marginBottom: "1rem" }}
          >
            <Grid item xs={4}>
              <Button
                variant="contained"
                color="primary"
                disabled={searching}
                onClick={() => setOpenDialog(true)}
              >
                <Add /> Criar Regra
              </Button>
            </Grid>
          </Grid>
        )}
      </Container>

      <DialogRules
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setRule(null);
          handleSearchRules({ page: 0, sizePerPage: 25 });
        }}
        rule={rule}
        typeOptions={typeOptions}
      />
    </>
  );
}
